import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Container, Spinner, Row, Col, Button,
} from 'react-bootstrap';
import { Placeholder, Svg } from '../../components/common';
import { onlineProducts, storeProducts } from '../../../api/api';
import { Constants, Utils } from '../../utilities';
import { errorImageFallback, getCDNImageUrl } from '../../utilities/Utils';
import * as LogClevertapEvent from '../../../clevertap/LogEvent';
import SellingStore from '../../components/derived/onlineProduct/SellingStore';

class SellingStores extends React.Component {
  constructor() {
    super();
    this.state = {
      product: null,
      loading: true,
      extend: false,
      errorMsg: '',
    };
  }

  componentDidMount=() => {
    this.handleLoad();
  }

  handleLoad = () => {
    const {
      productId, selectedAddress, cartId, isAppExOffer,
    } = this.props;
    const location = selectedAddress
      ? `${selectedAddress.location.lat},${selectedAddress.location.lng}`
      : '19.1207983,72.8782323';

    const apiCall = isAppExOffer
      ? storeProducts('GET', null, location, cartId, null, null, null, null, null, productId)
      : onlineProducts('get', null, location, cartId, null, null, null, null, null, productId);

    apiCall.then((res) => {
      if (res.status === 200) {
        this.setState({
          product: res.data,
          loading: false,
        });
      } else {
        throw new Error();
      }
    }).catch((error) => {
      this.setState(() => {
        if (
          error
          && error.response
          && error.response.status === 400
          && error.response.data
          && error.response.data[0]
        ) {
          return {
            loading: false,
            errorMsg: error.response.data[0].client_message,
          };
        }
        return {
          loading: false,
          error: true,
        };
      });
    });
  }

  render() {
    const {
      product, loading, error, extend, errorMsg,
    } = this.state;
    const {
      cartItems, isAppExOffer, isHome, isTopSavingOffer, isMobile,
      language, onClose, isProductDetailScreen,
    } = this.props;
    return (
      <Container
        id="offer-selling-stores"
        onScroll={() => {
          if (isMobile && !extend) {
            this.setState({
              extend: true,
            });
          }
        }}
        className={isMobile && extend
          ? 'vh-90' : ''}
      >
        <Row
          className="flex-column h-100 bg-white"
        >
          {loading && (
            <Col
              className="flex-grow-0 py-8 d-flex justify-content-center"
            >
              <Spinner
                animation="border"
                variant="primary"
              />
            </Col>
          )}
          {!loading && error && (
            <Col
              className="flex-grow-0 py-2"
            >
              <Placeholder
                language={language}
                handleRetry={() => {
                  this.setState({
                    loading: true,
                    error: false,
                  });
                  this.handleLoad();
                }}
              />
            </Col>
          )}
          {!loading && !error && errorMsg && (
            <Col
              className="flex-grow-0 py-8 d-flex justify-content-center fs-3"
            >
              {errorMsg}
            </Col>
          )}
          {!loading && !error && !errorMsg && product && (
            <Col
              className="flex-grow-1"
            >
              <Row
                className="h-100 flex-column"
              >
                <Col
                  className="p-4 flex-grow-0 border-bottom"
                >
                  <Row
                    className="mx-0 mb-3 align-items-start"
                  >
                    <Col
                      className={`pl-0 pr-2 ${isProductDetailScreen ? 'd-none' : ''}`}
                    >
                      <Row
                        className="mx-0 border rounded align-items-center
                            justify-content-center product-image-div"
                      >
                        <img
                          src={getCDNImageUrl(product.image)}
                          alt={product.displayName}
                          title={product.displayName}
                          onError={(event) => {
                            errorImageFallback(
                              event, Utils.LOVELOCAL.productPlaceholder,
                            );
                          }}
                          className="mh-100 mw-100"
                        />
                      </Row>
                    </Col>
                    {
                      !isMobile
                        && (
                          <Col
                            xs="auto"
                            className={`pl-2 pr-0 ${isProductDetailScreen ? 'ml-auto' : ''}`}
                          >
                            <Button
                              variant="link"
                              onClick={() => {
                                onClose();
                              }}
                              className="p-0 d-flex"
                            >
                              <Svg
                                svg="circleClose"
                                circleFill={Constants.Color.gray}
                                pathFill={Constants.Color.dark}
                                width="1.2rem"
                              />
                            </Button>
                          </Col>
                        )
                    }
                  </Row>
                  <div
                    className={`fs-4 ${isProductDetailScreen ? 'd-none' : ''}`}
                  >
                    <b>
                      {product.displayName}
                    </b>
                  </div>
                </Col>
                <Col
                  className="flex-grow-1 overflow-y-with-scrollbar"
                >
                  {product.sellingStores.map((sellingStore, index) => (
                    <div
                      key={sellingStore.store.id}
                      className={`py-4 ${index < product.sellingStores.length - 1
                        ? 'border-bottom' : ''}`}
                    >
                      <SellingStore
                        product={product}
                        sellingStore={sellingStore}
                        isMobile={isMobile}
                        language={language}
                        toggleSideOverlay={() => {}}
                        cartItems={cartItems}
                        onSuccess={(productCount) => {
                          if (isTopSavingOffer) {
                            LogClevertapEvent.offerTabAddedToCart(
                              sellingStore.store.displayName,
                              product.displayName,
                            );
                          }
                          if (isHome && isAppExOffer) {
                            if (productCount) {
                              LogClevertapEvent.homePageFlashSaleAdd(
                                product,
                                sellingStore.store.id,
                                sellingStore.store.displayName,
                              );
                            } else {
                              LogClevertapEvent.homePageFlashSaleRemove(
                                product,
                                sellingStore.store.id,
                                sellingStore.store.displayName,
                              );
                            }
                          }
                        }}
                        onClose={onClose}
                        isOfferSellingStores
                        isAppExOffer={isAppExOffer}
                        isTopSavingOffer={isTopSavingOffer}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  cartId: state.main.cartId,
  cartItems: state.main.cartItems,
  selectedAddress: state.main.selectedAddress,
});

SellingStores.propTypes = {
  cartId: PropTypes.string,
  cartItems: PropTypes.shape({}),
  isAppExOffer: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  isHome: PropTypes.bool,
  isTopSavingOffer: PropTypes.bool,
  isProductDetailScreen: PropTypes.bool,
  language: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  productId: PropTypes.number.isRequired,
  selectedAddress: PropTypes.shape({
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }),
};

SellingStores.defaultProps = {
  cartId: null,
  cartItems: null,
  isAppExOffer: false,
  isHome: false,
  isTopSavingOffer: false,
  isProductDetailScreen: false,
  onClose: () => {},
  selectedAddress: null,
};

export default connect(mapStateToProps)(SellingStores);
